import { APISettings } from '../../config/ApiSettings';
import { BaseAPI } from './baseApi';
const baseUrl = new APISettings().getApiURL();

class ProposedRuleImageAPI<ProposedRuleImage> extends BaseAPI {
  // constructor() {}

  public getByProposedRuleId: (proposedRuleId: number) => Promise<ProposedRuleImage[]> = async (
    proposedRuleId: number
  ) => {
    return (
      await BaseAPI.axios.get(`${baseUrl}/ProposedRuleImage/GetByProposedRuleId/${proposedRuleId}`)
    ).data.output;
  };

  public createProposedRuleImage: (
    proposedRuleImage: ProposedRuleImage
  ) => Promise<ProposedRuleImage> = async (proposedRuleImage: ProposedRuleImage) => {
    return await BaseAPI.axios.post(`${baseUrl}/ProposedRuleImage`, proposedRuleImage);
  };

  public deleteById: (id: number) => Promise<ProposedRuleImage> = async (id: number) => {
    return await BaseAPI.axios.delete(`${baseUrl}/ProposedRuleImage/${id}`);
  };

  public deleteByBlobName: (blobName: string) => Promise<ProposedRuleImage> = async (
    blobName: string
  ) => {
    return await BaseAPI.axios.delete(`${baseUrl}/ProposedRuleImage/${blobName}`);
  };
}

export const proposedRuleImageAPI = new ProposedRuleImageAPI();
